import { render } from "./HelloWorld.vue?vue&type=template&id=c24bfd86&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=c24bfd86&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c24bfd86"

export default script